import $ from 'jquery';
import * as YandexLoader from 'ymaps';
import PerfectScrollbar from 'perfect-scrollbar';


(function () {
    const data = {
        markers: window.mapMarkers,
        sections: window.mapSections,
        city: window.currentCity,
        map: null,
        objectManager: null,
        scrollbar: null
    };
    const form = $('.js-submit-services');

    form.on('submit',function (e){
        e.preventDefault();
    })
    const findCityId = (cityName) => {
        for (const id in data.sections) {
            if (data.sections.hasOwnProperty(id)) {
                const section = data.sections[id];
                if (section.name.toLowerCase() === cityName.toLowerCase()) {
                    return section.id;
                }
            }
        }
        return null; // Если город не найден
    };

    const scrollbarInit = () => {
        if ($('#services-items').length > 0) {
            data.scrollbar = new PerfectScrollbar('#services-items', {
                wheelSpeed: 2,
                wheelPropagation: true,
                minScrollbarLength: 100
            });
        }
    };

    if ($(window).width() > 768) {
        scrollbarInit();
    }

    $(window).resize(function () {
        const width = $(window).width();

        if (width > 768) {
            if (data.scrollbar) {
                data.scrollbar.update();
            } else {
                // reinit on desktop
                scrollbarInit();
            }
        } else {
            if (data.scrollbar) {
                // destroy on mobile
                data.scrollbar.destroy();
                data.scrollbar = null;
            }
        }
    });

    const getFeatureCollection = () => {
        const markerIds = Object.keys(data.markers);
        const features = [];

        markerIds.forEach((markerId) => {
            const marker = data.markers[markerId];
            features.push({
                id: markerId,
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [marker.lat, marker.lng]
                },
                properties: {
                    hintContent: marker.name,
                    id: markerId,
                    lat: marker.lat,
                    lng: marker.lng
                }
            });
        });

        return {
            type: 'FeatureCollection',
            features
        };
    };

    const updateMap = (categoryId = false) => {
        if (categoryId === false) {
            data.objectManager.setFilter(() => true);
        } else {
            if (data.sections[categoryId] !== undefined) {
                const section = data.sections[categoryId];
                data.objectManager.setFilter((item) => {
                    return section.markers.indexOf(+item.id) > -1;
                });
            }
        }

        data.map.setBounds(
            data.map.geoObjects.getBounds(),
            { checkZoomRange: true }
        ).then(() => {
            if (data.map.getZoom() > 14) {
                data.map.setZoom(14);
            }
        });
    };

    if (window.location.pathname.indexOf('/services') === -1) {
        return;
    }
    $('.preloader').css('display','flex');

    YandexLoader.default.load('https://api-maps.yandex.ru/2.1/?apikey=08c8d65a-b50d-4915-97ad-f06875a6d428&lang=ru_RU').then((ymaps) => {
        if (window.mapMarkers === undefined) {
            return;
        }
        $('.preloader').hide();
        ymaps.ready(() => {
            data.map = new ymaps.Map('services-map', {
                center: [55.76, 37.64],
                zoom: 7,
                controls: ['zoomControl']
            });

            data.objectManager = new ymaps.ObjectManager({
                // Чтобы метки начали кластеризоваться, выставляем опцию.
                clusterize: true,
                // ObjectManager принимает те же опции, что и кластеризатор.
                gridSize: 32,
                hasBalloon: false,
                // clusterDisableClickZoom: true,
                clusterHideIconOnBalloonOpen: false,
                geoObjectHideIconOnBalloonOpen: false
            });

            data.objectManager.objects.options.set('preset', 'islands#redDotIcon');
            data.objectManager.clusters.options.set('preset', 'islands#redClusterIcons');
            data.map.geoObjects.add(data.objectManager);
            data.objectManager.add(getFeatureCollection());

            data.objectManager.events.add('click', function (e) {
                // Получение ссылки на дочерний объект, на котором произошло событие.
                const id = e._sourceEvent._sourceEvent.originalEvent.objectId;
                const selector = `.services-item--${id}`;
                if ($(selector).length > 0) {
                    const servicesItemsDom = $('#services-items')[0];
                    servicesItemsDom.scrollTop = 0;
                    servicesItemsDom.scrollLeft = 0;
                    if ($(window).width() > 768) {
                        const scrollTop = $(selector).offset().top - $(selector).offsetParent().offset().top - 10;
                        servicesItemsDom.scrollTop = scrollTop > 0 ? scrollTop : 0;
                    } else {
                        const scrollLeft = $(selector).offset().left - $(selector).offsetParent().offset().left - 10;
                        servicesItemsDom.scrollLeft = scrollLeft > 0 ? scrollLeft : 0;
                    }
                }
            });

            updateMap(); // Обновление карты без categoryId

            const cityId = findCityId(data.city);

            if (cityId !== null) {
                const categoryName = data.sections[cityId].name;
                $('.control-autocomplete')
                    .addClass('control-autocomplete--active')
                    .attr('data-value', categoryName);

                $('.services-item').hide();
                $(`.services-item-section--${cityId}`).show();
                if (data.scrollbar) {
                    data.scrollbar.update();
                }
                updateMap(cityId);
            }
        });
    });

    $('.control-autocomplete input').keyup(function () {
        const items = [];
        const searchString = $(this).val().toLowerCase();

        Object.keys(data.sections).forEach((sectionId) => {
            if (data.sections[sectionId].name && data.sections[sectionId].name.toLowerCase().indexOf(searchString) > -1) {
                items.push(data.sections[sectionId]);
            }
        });

        $('.control-autocomplete__options').html('');
        if (items.length === 0) {
            $('.control-autocomplete__options').html('<div class="control-autocomplete__nothing">По вашему запросу ничего не найдено</div>');
        } else {
            items.forEach((item) => {
                $('.control-autocomplete__options').append(
                    `<div class="control-autocomplete__option" data-value="${item.id}">${item.name}</div>`
                );
            });
        }
        $('.control-autocomplete__options').show();
    });

    $('.control-autocomplete').on('click', '.control-control-autocomplete__nothing', function () {
        $('.control-autocomplete__options').hide();
    });

    $('.control-autocomplete').on('click', '.control-autocomplete__option', function (e) {
        e.preventDefault();
        $(this).blur();

        const categoryId = $(this).attr('data-value');
        const categoryName = $(this).text().trim();

        $('.control-autocomplete__options').hide();
        $('.control-autocomplete')
            .addClass('control-autocomplete--active')
            .attr('data-value', categoryName);

        $('.services-item').hide();
        $(`.services-item-section--${categoryId}`).show();
        if (data.scrollbar) {
            data.scrollbar.update();
        }
        updateMap(categoryId);
    });

    $('.control-autocomplete input').blur(function () {
        setTimeout(() => {
            $('.control-autocomplete__options').hide();
            $('.control-autocomplete input').val($('.control-autocomplete').attr('data-value'));
        }, 300);
    });

    $('.control-autocomplete-clear').click(function () {
        $('.control-autocomplete')
            .removeClass('control-autocomplete--active')
            .attr('data-value', '');
        $('.control-autocomplete input').val('');
        $('.services-item').show();
        updateMap();
    });

    $('.services-items').on('click', '.services-item', function () {
        const marker = data.markers[$(this).attr('data-id')];
        data.map.setCenter([marker.lat, marker.lng], 14, {
            checkZoomRange: true
        });
    });

    $('.services-item').click(function () {
        $('.services-item').removeClass('services-item--opened');
        $(this).toggleClass('services-item--opened');
    });
}());
